import { ValueOf } from '@ahha/utils/@types/typeUtils'

export const ModelTypes = {
  ANOMALY_DETECTION: 'ANOMALY_DETECTION',
  SEGMENTATION: 'SEGMENTATION',
  CLASSIFICATION: 'CLASSIFICATION',
  OBJECT_DETECTION: 'OBJECT_DETECTION',
  IMAGE_ENHANCEMENT: 'IMAGE_ENHANCEMENT',
  OCR: 'OCR',
  // VIDEO: 5,
  // TABULAR: 6,
} as const

export const TrainingModelTypes = {
  ANOMALY_MEDIUM: 'MEDIUM',
  ANOMALY_SMALL: 'SMALL',
  ANOMALY_LARGE: 'LARGE',
  SEGMENTATION: 'SEGMENTATION', // 미사용
  CLASSIFICATION: 'CLASSIFICATION', // 미사용
  CLASSIFICATION_CONVNEXT_T: 'CONVNEXT_T',
  CLASSIFICATION_LARGE: 'MMCLS_LARGE',
  OBJECT_DETECTION: 'OBJECT_DETECTION', // 미사용
  IE_VIT: 'VIT',
  IE_CNN: 'CNN',
  IE_CNN_MEDIUM: 'CNN_MEDIUM',
  OCR: 'OCR', // 미사용
  SERIES_TRANSFORMER: 'transformer',
  SERIES_LSTM: 'LSTM',
  SERIES_CATBOOST: 'CatBoost',
  SERIES_XGBOOST: 'XGBoost',
  SERIES_LGBM: 'LGBM',
}
export type ModelValueType = ValueOf<typeof ModelTypes>
export type TrainingModelValueType = ValueOf<typeof TrainingModelTypes>
export const MODEL_LABELS: Record<string, string> = {
  ANOMALY_DETECTION: 'common_anomalyDetection',
  SEGMENTATION: 'common_segmentation',
  CLASSIFICATION: 'common_classification',
  OBJECT_DETECTION: 'common_objectDetection',
  IMAGE_ENHANCEMENT: 'common_imageEnhancement',
  OCR: 'common_ocr',
}

export const HyperParameterTypes = {
  ANOMALY_DETECTION_SMALL: 'ANOMALY_DETECTION_SMALL',
  ANOMALY_DETECTION_MEDIUM: 'ANOMALY_DETECTION_MEDIUM',
  ANOMALY_DETECTION_LARGE: 'ANOMALY_DETECTION_LARGE',
  SEGMENTATION: 'SEGMENTATION',
  CLASSIFICATION: 'CLASSIFICATION',
  CLASSIFICATION_CONVNEXT_T: 'CLASSIFICATION_CONVNEXT_T',
  CLASSIFICATION_LARGE: 'CLASSIFICATION_LARGE',
  OBJECT_DETECTION: 'OBJECT_DETECTION',
  IMAGE_ENHANCEMENT_CNN: 'IMAGE_ENHANCEMENT_CNN',
  IMAGE_ENHANCEMENT_CNN_MEDIUM: 'IMAGE_ENHANCEMENT_CNN_MEDIUM',
  IMAGE_ENHANCEMENT_VIT: 'IMAGE_ENHANCEMENT_VIT',
  OCR: 'OCR',
  SERIES_TRANSFORMER: 'SERIES_TRANSFORMER',
  SERIES_LSTM: 'SERIES_LSTM',
  SERIES_CATBOOST: 'SERIES_CATBOOST',
  SERIES_XGBOOST: 'SERIES_XGBOOST',
  SERIES_LGBM: 'SERIES_LGBM',
  SERIES_AD_TRANSFORMER: 'SERIES_AD_TRANSFORMER',
  TABULAR_CLS_TRANSFORMER: 'TABULAR_CLS_TRANSFORMER',
  TABULAR_CLS_LSTM: 'TABULAR_CLS_LSTM',
  TABULAR_CLS_CATBOOST: 'TABULAR_CLS_CATBOOST',
  TABULAR_CLS_XGBOOST: 'TABULAR_CLS_XGBOOST',
  TABULAR_CLS_LGBM: 'TABULAR_CLS_LGBM',
  TABULAR_AD_TRANSFORMER: 'TABULAR_AD_TRANSFORMER',
} as const
export type HyperParameterType = ValueOf<typeof HyperParameterTypes>

export const TRAINING_MODEL_I18N_KEYS: Record<string, string> = {
  ANOMALY_DETECTION_MEDIUM: 'model_anomalyDetection_medium',
  ANOMALY_DETECTION_SMALL: 'model_anomalyDetection_small',
  SEGMENTATION: 'model_segmentation',
  CLASSIFICATION: 'model_classification',
  CLASSIFICATION_CONVNEXT_T: 'timm/convnext_tiny.fb_in22k_ft_in1k_384',
  OBJECT_DETECTION: 'model_objectDetection',
  IMAGE_ENHANCEMENT_CNN: 'model_settings_imageEnhancement_CNN',
  IMAGE_ENHANCEMENT_VIT: 'model_settings_imageEnhancement_ViT',
  IMAGE_ENHANCEMENT_CNN_MEDIUM: 'model_settings_imageEnhancement_CNN_medium',
  OCR: 'model_ocr',
}

export const EvaluationTypes = {
  TRAIN: 'TRAIN',
  VALIDATION: 'VALIDATION',
  INFERENCE: 'INFERENCE',
  MODEL_PIPELINE: 'MODEL_PIPELINE',
} as const
export type EvaluationValueType = ValueOf<typeof EvaluationTypes>

export const ModelColors = {
  ANOMALY_DETECTION: '#1FB356',
  SEGMENTATION: '#F97316',
  CLASSIFICATION: '#F2BC1A',
  OBJECT_DETECTION: '#1A75FF',
  IMAGE_ENHANCEMENT: '#CEB0FA',
  OCR: '#3DD3ED',
  'OD-AD-CLS': '#FFFFFF',
  'OD-SEG': '#FFFFFF',
}

export const TaskStatusTypes = {
  CREATED: 'CREATED',
  PREPARING: 'PREPARING',
  WAITING: 'WAITING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  PAUSING: 'PAUSING',
  PAUSED: 'PAUSED',
  RESUMED: 'RESUMED',
  CANCELED: 'CANCELED',
  TERMINATED: 'TERMINATED',
  ERROR: 'ERROR',
  TIMEOUT: 'TIMEOUT',
  UNKNOWN: 'UNKNOWN',
  STOPPING: 'STOPPING',
  PENDING: 'PENDING',
  BLOCKED: 'BLOCKED',
  INSUFFICIENT_CREDIT: 'INSUFFICIENT_CREDIT',
} as const
export type TaskStatusValueType = ValueOf<typeof TaskStatusTypes>

export const COMPLETED_TASKS: TaskStatusValueType[] = [
  TaskStatusTypes.COMPLETED,
  TaskStatusTypes.STOPPING,
]

export const ERROR_TASKS: TaskStatusValueType[] = [
  TaskStatusTypes.ERROR,
  TaskStatusTypes.TIMEOUT,
  TaskStatusTypes.UNKNOWN,
]
export const RUNNING_TASKS: TaskStatusValueType[] = [
  TaskStatusTypes.CREATED,
  TaskStatusTypes.PREPARING,
  TaskStatusTypes.WAITING,
  TaskStatusTypes.RUNNING,
  TaskStatusTypes.RESUMED,
  TaskStatusTypes.STOPPING,
]

export const WAITING_RESULT_TASKS: TaskStatusValueType[] = [
  TaskStatusTypes.PAUSING, // 일시정지 버튼 누르고 paused 되기 전까지
  TaskStatusTypes.RESUMED, // 재개 버튼 누르고 running 되기 전까지
  TaskStatusTypes.STOPPING, // 중지 버튼 누르고 completed 되기 전까지
]

export const MAX_NODE_NAME_LENGTH = 80
export const MAX_PROJECT_NAME_LENGTH = 60

export const LabelingBlockingTypes = {
  EDITING_BLOCKED: 'editingBlocked', // 모델 재학습시, 자동생성된 라벨링 노드에서 수동 검수 체크 안한 경우
  NODE_COMPLETED: 'nodeCompleted',
  REVIEW_ONGOING: 'reviewOngoing',
  REVIEW_PENDING: 'reviewPending',
  PERMISSION: 'permission',
  FINISHED: 'finished',
  COMPLETED: 'completed',
  NO_CLASS: 'noClass',
} as const

export type LabelingBlockingType = ValueOf<typeof LabelingBlockingTypes> | null

export const excludeEmailList = [/@gmail\.com/, /@yahoo\.com/, /@naver\.com/, /@daum\.net/, /@outlook\.com/, /@hotmail\.com/, /@protonmail\.com/, /@icloud\.com/, /@mail\.com/, /@kakao\.com/, /@hanmail\.net/]

export const FORBIDDEN_NODE_NAME_CHARS = /[₩/:*?"<>|\\]/

// Time Series / Tabular processing task type
export const TABULAR_REQUEST_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
}
export type TabularRequestStatusType = ValueOf<typeof TABULAR_REQUEST_STATUS>
